var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("material-input", {
          attrs: { label: _vm.$t("account.givenName") },
          model: {
            value: _vm.givenName,
            callback: function ($$v) {
              _vm.givenName = $$v
            },
            expression: "givenName",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("material-input", {
          attrs: { label: _vm.$t("account.familyName") },
          model: {
            value: _vm.familyName,
            callback: function ($$v) {
              _vm.familyName = $$v
            },
            expression: "familyName",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("material-input", {
          attrs: { label: _vm.$t("account.email"), type: "email" },
          model: {
            value: _vm.email,
            callback: function ($$v) {
              _vm.email = $$v
            },
            expression: "email",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c(
          "material-input",
          { attrs: { value: _vm.phone, label: _vm.$t("account.phoneNumber") } },
          [
            _c("phone-input", {
              key: "phone",
              staticClass: "material-input form-control form",
              class: { "form-control-filled": !!_vm.phone },
              attrs: {
                id: _vm.labelValue,
                name: "co-app-phone",
                "data-lpignore": "true",
                type: "text",
                value: _vm.phone,
                "emit-value": true,
              },
              on: {
                change: function (val) {
                  return (_vm.phone = val)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "d-none", attrs: { for: _vm.labelValue } },
              [_vm._v(_vm._s(_vm.$t("account.phoneNumber")))]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }